var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationAnnouncementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9411 0 36 8.05876 36 18C36 27.9412 27.9411 36 18 36C8.05889 36 0 27.9412 0 18C0 8.05876 8.05889 0 18 0Z",
    fill: "#F48366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1641 15.0522L25.9137 12.31C26.2477 12.1167 26.3637 11.6878 26.1704 11.3503C25.977 11.0163 25.5481 10.9003 25.2106 11.0936L20.461 13.8358C20.127 14.0292 20.011 14.4581 20.2044 14.7956C20.3977 15.1331 20.8301 15.2456 21.1641 15.0522Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2969 16.9049H20.8125C20.4258 16.9049 20.1094 17.2213 20.1094 17.608C20.1094 17.9948 20.4258 18.3112 20.8125 18.3112H26.2969C26.6836 18.3112 27 17.9948 27 17.608C27 17.2213 26.6836 16.9049 26.2969 16.9049Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.348 12.7987C18.1477 12.6687 17.898 12.6476 17.6801 12.746L13.4227 14.6444H9.70313C9.31641 14.6444 9 14.9608 9 15.3476V19.8687C9 20.2554 9.31641 20.5718 9.70313 20.5718H11.6367V23.2331C11.6367 23.6198 11.9531 23.9362 12.3398 23.9362C12.7266 23.9362 13.043 23.6198 13.043 23.2331V20.5718H13.4191L17.6766 22.4702C17.8945 22.5687 18.1441 22.5476 18.3445 22.4175C18.5449 22.2874 18.6645 22.0659 18.6645 21.8269V13.3894C18.668 13.1503 18.5484 12.9288 18.348 12.7987ZM17.2617 20.7441L13.8551 19.2253C13.7637 19.1866 13.6688 19.1655 13.5703 19.1655C11.8898 19.1655 10.5539 19.1655 10.4063 19.1655V16.0507H13.5703C13.6688 16.0507 13.7672 16.0296 13.8551 15.9909L17.2617 14.4722V20.7441Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9136 22.9061L21.164 20.164C20.8301 19.9706 20.3976 20.0866 20.2043 20.4206C20.0109 20.7546 20.1234 21.187 20.4609 21.3804L25.2105 24.1225C25.5445 24.3159 25.9769 24.2034 26.1703 23.8659C26.3636 23.5284 26.2511 23.0995 25.9136 22.9061Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAnnouncementIcon);
export default __webpack_public_path__ + "static/media/notification_announcement_icon.4bb7226be6507c33e1470408e47cabef.svg";
export { ForwardRef as ReactComponent };